var _ = require('underscore');
var $ = require('jquery');
var Backgrid = require('backgrid');
var Behaviors = require('Behaviors');
var Dialog = require('Dialog');
var EdwCDALookup = require('EdwCDALookup');
var Grid = require('Grid');
var Labels = EY.Consultation.Labels;
var Marionette = require('marionette');
var Resources = EY.Consultation.Resources;
var Validation = require('validation');

var Action = Marionette.View.extend({
    events: {
        'click': 'action'
    },    
    tagName: 'td',
    template: '#edwClientSearchGridAction',
    className: 'select-engagement',
    ui: {
        data: '#data'
    },
    onRender: function () {
        this.ui.data.text(this.model.get(this.options.column.get("name")));
    },
    action: function () {
        if (this.model.collection.findWhere({ selected: true }))
            this.model.collection.findWhere({ selected: true }).set("selected", false);
            
        this.model.set({"selected":true},{silent:true});

        $('#clientNameSearchGrid').find('td').removeClass("mark");
        this.$el.parent().find("td").addClass("mark");
    }
});
var LargeCell = Marionette.View.extend({
    events: {
        'click': 'action'
    },
    tagName: 'td',
    template: '#edwClientSearchGridAction',
    className: 'select-engagement visible-lg visible-md',
    ui: {
        data: '#data'
    },
    onRender: function () {
        this.ui.data.text(this.model.get(this.options.column.get("name")));
    },
    action: function () {
        if (this.model.collection.findWhere({ selected: true }))
            this.model.collection.findWhere({ selected: true }).set("selected", false);
            
        this.model.set({"selected":true},{silent:true});

        $('#clientNameSearchGrid').find('td').removeClass("mark");
        this.$el.parent().find("td").addClass("mark");
    }
});

var SmallCell = Marionette.View.extend({
    events: {
        'click': 'action'
    },
    tagName: 'td',
    template: '#edwClientSearchGridAction',
    className: 'select-engagement visible-sm visible-xs',
    ui: {
        data: '#data'
    },
    onRender: function () {
        this.ui.data.text(this.model.get(this.options.column.get("name")));
    },
    action: function () {
        if (this.model.collection.findWhere({ selected: true }))
            this.model.collection.findWhere({ selected: true }).set("selected", false);

        this.model.set({ "selected": true }, { silent: true });

        $('#clientNameSearchGrid').find('td').removeClass("mark");
        this.$el.parent().find("td").addClass("mark");
    }
});

var largeHeaderCell = Backgrid.HeaderCell.extend({
    render: function () {
        Backgrid.HeaderCell.prototype.render.apply(this, arguments);
        this.$el.addClass('visible-lg visible-md');
        return this
    }
});
var smallerHeaderCell = Backgrid.HeaderCell.extend({
    render: function () {
        Backgrid.HeaderCell.prototype.render.apply(this, arguments);
        this.$el.addClass('visible-sm visible-xs');
        return this
    }
});

//this should contain the columns for the client/engagement search
var graphColumns = function () {
    return [{ name: 'EngagementId', label: Labels.EngagementNumber, editable: false, cell: LargeCell, headerCell: largeHeaderCell },
    { name: 'EngagementId', label: Labels.EngagementNumber, editable: false, cell: SmallCell, headerCell: smallerHeaderCell },
    { name: 'EngagementName', label: Labels.EngagementName, editable: false, cell: LargeCell, headerCell: largeHeaderCell },
    { name: 'EngagementName', label: Labels.EngagementName, editable: false, cell: SmallCell, headerCell: smallerHeaderCell },
    { name: 'ClientName', label: Labels.ClientName, editable: false, cell: Action },
    { name: 'ClientId', label: Labels.ClientCode, editable: false, cell: LargeCell, headerCell: largeHeaderCell },
    { name: 'Country', label: Labels.Country, editable: false, cell: Action }];
};





var Layout = Marionette.View.extend({
    template: '#edwClientNameSearchLayout',
    behaviors: [Behaviors.Tooltip,Behaviors.MobileView],
    regions: {
        clientNameSearchGrid: '#clientNameSearchGrid',
    },
    ui:{
        keyword:'#keyword',
        search:'#search'
    },
    events:{
        'click @ui.search':'search',
        'keypress input[type=text]': 'enter'
    },
    initialize: function () {
        Validation.bind(this);
    },
    onRender:function(){
        this.ui.keyword.val(this.options.engagement);
       Grid.show({
            collection:this.options.collection,
            columns: graphColumns(),
            region:this.getRegion('clientNameSearchGrid')
       });
    },
    enter:function(e){
        if (e.keyCode === 13) {
            this.search();
        }
    },
    search:function(){
        var context = this;
        var collection = this.options.collection;
        var engagement = this.ui.keyword.val();
        var isEngagementSearch = (engagement.match(/^[A-Za-z][-]/) || engagement.match(/^[0-9]*$/)) && (engagement.length===8  || engagement.length===10);
        var isClientSearch = !(engagement.match(/^[A-Za-z][-]/)) && engagement.length > 2;
        var cdaPromise = (isEngagementSearch ? EdwCDALookup.getEngagement(engagement) : isClientSearch ? EdwCDALookup.searchClients(engagement) : null);

        if (!isEngagementSearch && !isClientSearch) {

            collection.reset();
        } else {

            $('html,body').addClass('wait-cursor');
            cdaPromise.then(function(engagements) {

                context.loadEngagements(collection, engagements);
                $('html,body').removeClass('wait-cursor');

            }).catch(function(error) {

                collection.reset();
                $('html,body').removeClass('wait-cursor');
                console.log('error', error);
            });
        }
    },
    loadEngagements: function (collection, engagements) {

        var context = this;
        
        var recordCountry = _.findWhere(Resources.Countries, { id: context.options.record.get('countryId') });
        var code = recordCountry && recordCountry.code;
        var processedEngagements = _.flatten(
            _.partition(_.sortBy(engagements,function (e) {
                return e.EngagementName.trim(); }), function (eng) {
            return eng.CountryCode === code;
        }));

        collection.reset(processedEngagements);
    }
});

module.exports.show = function(options){
    var validationModel = new Backbone.Model();
    validationModel.validation = _.extend([], {
        engagement: function (value) {
            return !options.collection.any({ selected: true }) ? Labels.AddWarning : ''; 
        }
    });
    var layout = new Layout(_.extend(options,{model:validationModel}));
    return Dialog.show({
        cancelLabel: Labels.Cancel,
        headerLabel: Labels.EngagementInformation,
        saveLabel: Labels.Add,
        validate: validationModel,
        view: layout,
        size: "modal-xl"
    }).done(function(){
        var engagement = options.collection.find({ selected: true });
        if (engagement) {
            options.record.set('showManualInfo', false);
            options.record.set({
                clientId: engagement.get('ClientId'),
                clientName: engagement.get('ClientName'),
                engagementId: engagement.get('EngagementId'),
                engagementName: engagement.get('EngagementName'),
                invalidEngagement: false
            });
            var edwIndustry = _.find(EY.Consultation.Resources.Industry,{edw:engagement.get('IndustrySector')});
            if(edwIndustry){
                options.record.set('industryId',edwIndustry.id);
            }else{
                options.record.set('industryId','');
            }
            options.collection.reset();
            layout.triggerMethod('selectionChanged');
        }else {
            require('Consultation').showToast({ result: "info", text: Labels.NoEngagementDetailsWereUpdated});
        }
        $('html,body').removeClass('wait-cursor');
    }).fail(function(){
        options.collection.reset();
        $('html,body').removeClass('wait-cursor');
    });
}


// WEBPACK FOOTER //
// ./js/Modules/Service/EdwClientEngagementSearch.js